import React, { useState } from "react";
import clsx from "clsx";
import CurrencyInput from "components/form/currency-input";

const AddItems = ({ onSuccess, onCancel }) => {

    const [formData, setFormData] = useState({
        name: '',
        description: '',
        qty: '',
        price: '',
    });

    return (
        <form onSubmit={(e) => {
            e.preventDefault();
            onSuccess(formData);
        }} style={{ height: '100%' }}>
            <div className="container-fluid mt-4">
                <div className="row mb-3 align-items-center">
                    <label htmlFor="name" className="col-sm-4 col-form-label d-flex justify-content-end" style={{ fontSize: '14px' }}>Name: </label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            className={clsx("form-control")}
                            id="name"
                            placeholder="Item name"
                            name="name"
                            value={formData.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                            style={{ fontSize: '14px', height: '35px' }}
                            required
                        />
                    </div>
                </div>

                <div className="row mb-3 align-items-center">
                    <label htmlFor="description" className="col-sm-4 col-form-label d-flex justify-content-end" style={{ fontSize: '14px' }}>Description: </label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            className={clsx("form-control")}
                            id="description"
                            placeholder="Item description"
                            name="description"
                            value={formData.description}
                            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                            style={{ fontSize: '14px', height: '35px' }}
                            required
                        />
                    </div>
                </div>

                <div className="row mb-3 align-items-center">
                    <label htmlFor="qty" className="col-sm-4 col-form-label d-flex justify-content-end" style={{ fontSize: '14px' }}>Quantity (Qty): </label>
                    <div className="col-sm-8">
                        <input
                            type="number"
                            className={clsx("form-control")}
                            id="qty"
                            placeholder="Quantity"
                            name="qty"
                            min={1}
                            value={formData.qty}
                            onChange={(e) => setFormData({ ...formData, qty: e.target.value })}
                            style={{ fontSize: '14px', height: '35px' }}
                            required
                        />
                    </div>
                </div>

                <div className="row mb-3 align-items-center">
                    <label htmlFor="price" className="col-sm-4 col-form-label d-flex justify-content-end" style={{ fontSize: '14px' }}>Price: </label>
                    <div className="col-sm-8">
                        <CurrencyInput
                            value={formData.price}
                            onChange={(e, rawValue) => setFormData({ ...formData, price: rawValue })}
                            className="form-control"
                            style={{ fontSize: '14px', height: '35px' }}
                            required
                        />
                    </div>
                </div>

                <div className="form-group mt-auto d-flex justify-content-between">
                    <button type="button" className="btn btn-secondary" style={{ height: '40px' }} onClick={onCancel}>
                        Cancel
                    </button>
                    <button type="submit" className="btn btn-primary" style={{ height: '40px' }}>
                        Save Item
                    </button>
                </div>
            </div>
        </form>
    );
};

export default AddItems;